export default __webpack_public_path__ + "static/media/gas_app_partners_large_icon.6404a14a.svg";